import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PM_V2_Due_Equipment_Item_Interface, PM_V2_Due_Execution_History_Interface } from '../../../Interface/PM_V2_Interface';
import { AlertifyService } from '../../../Service/Alertify.service';
import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-pm-v2-due-equipment-detail',
  templateUrl: './PM_V2_DueEquipmentDetail.component.html',
  styleUrls: ['./PM_V2_DueEquipmentDetail.component.css']
})
export class PM_V2_DueEquipmentDetailComponent implements OnInit {
  EquipmentId = 0;
  DataList: PM_V2_Due_Equipment_Item_Interface[] = [];
  HistoryList: PM_V2_Due_Execution_History_Interface[] = [];
  Procssing = false;
  HistoryProcessing = false;
  page=0
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: PM_V2_Service,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService) { }

  ngOnInit(): void {
    this.Nav_Service.CheckValidPage(2240).subscribe(() => {
      this.EquipmentId = Number(this.route.snapshot.paramMap.get('equipmentId') || 0);
      if (this.EquipmentId <= 0) {
        this.Back();
        return;
      }
      this.ReadData();
    }, () => {
      // AuthInterceptor owns authentication; feature errors must preserve credentials.
    });
  }

  get Context(): PM_V2_Due_Equipment_Item_Interface | null {
    return this.DataList.length ? this.DataList[0] : null;
  }

  ReadData() {
    this.Procssing = true;
    this.service.GetDueEquipmentItems(this.EquipmentId).subscribe(data => {
      this.DataList = data || [];
      this.Procssing = false;
      const context = this.Context;
      if (context) this.ReadHistory(context.Template_ID);
      else this.HistoryList = [];
    }, () => {
      this.Procssing = false;
      this.Alertify_Service.ErrorMessage('خطا در دریافت جزئیات PM تجهیز.');
    });
  }

  ReadHistory(templateId: number) {
    this.HistoryProcessing = true;
    this.service.GetDueExecutionHistory(this.EquipmentId, templateId).subscribe(data => {
      this.HistoryList = data || [];
      this.HistoryProcessing = false;
    }, () => {
      this.HistoryProcessing = false;
      this.Alertify_Service.ErrorMessage('خطا در دریافت تاریخچه اجرای PM.');
    });
  }

  Status(item: PM_V2_Due_Equipment_Item_Interface): string {
    if (item.Is_Never_Executed) return 'منتظر اولین PM';
    if (item.Can_Execute) return 'سررسید شده';
    return 'فعال';
  }

  StatusClass(item: PM_V2_Due_Equipment_Item_Interface): string {
    if (item.Is_Never_Executed) return 'badge-info';
    if (item.Can_Execute) return 'badge-danger';
    return 'badge-success';
  }

  Execute(item: PM_V2_Due_Equipment_Item_Interface) {
    if (!item.Can_Execute) return;
    this.router.navigate(['/pm-v2/execution/add', item.Assignment_Item_ID], {
      queryParams: { returnUrl: this.router.url }
    });
  }

  Back() {
    this.router.navigate(['/pm-v2/due']);
  }
}
